{
  "app": {
    "name": "Azimut",
    "welcome": "Bienvenue sur Azimut",
    "loading": "Chargement...",
    "404": "Oups, cette page semble ne pas exister",
    "returnToHome": "Retourner à l'accueil"
  },
  "errorOccurred": "Une erreur s'est produite",
  "errorBoundary": {
    "title": "Erreur de téléchargement des données",
    "description": "Une erreur s'est produite lors du chargement des données. Veuillez réessayer plus tard.",
    "returnHome": "Relancer"
  },
  "navigation": {
    "home": "Accueil",
    "back": "Back",
    "showPageNavigator": "Afficher le navigateur de pages",
    "hidePageNavigator": "Masquer le navigateur de pages",
    "zoomIn": "Aggrandir",
    "zoomOut": "Réduire",
    "continuedOnPage": "Éléments sur l'autre page"
  },
  "actions": {
    "save": "Enregistrer",
    "saveAndClose": "Enregistrer et fermer",
    "submitValidation": "Soumettre la validation",
    "submittingValidation": "Soumission en cours",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "close": "Fermer",
    "confirm": "Confirmer",
    "start": "Débuter",
    "continue": "Continuer"
  },
  "common": {
    "refresh": "Actualiser",
    "lastUpdatedAt": "Dernière mise à jour : {{updatedAt}}",
    "unknown": "Inconnu(e)",
    "end": "Fin",
    "yes": "Oui",
    "no": "Non",
    "selectPlaceholder": "Sélectionner..."
  },
  "policy": {
    "spill": "Déversement",
    "accountName": "Nom de compte",
    "fileName": "Nom du fichier",
    "policyNumber": "# de Police",
    "insurer": "Assureur",
    "expiryDate": "Date d'échéance",
    "technicalSupport": "Soutien technique",
    "status": "Statut",
    "assignation": "Assignation",
    "validationDate": "Date de validation",
    "filter": {
      "accountName": "Filtrer nom de compte...",
      "fileName": "Filtrer nom du fichier...",
      "policyNumber": "Filtrer # de police...",
      "insurer": "Filtrer assureur...",
      "technicalSupport": "Filtrer soutien technique...",
      "status": "Filtrer statut",
      "allStatus": "Tous"
    },
    "noPoliciesFound": "Aucune police trouvée",
    "loadingPolicies": "Chargement des polices...",
    "inProgressTooltip": "Cette police est déjà en cours de validation par un autre utilisateur. Veuillez rafraichir pour actualiser le statut.",
    "noPdfAvailable": "Aucun PDF disponible",
    "startPolicyErrorTitle": "Police déjà ouverte",
    "startPolicyErrorDescription": "Cette police est en cours de consultation par un autre utilisateur. La synchronisation automatique peut prendre jusqu'à 30s. Vous pouvez aussi rafraîchir maintenant.",
    "assignmentConflictTitle": "Police modifiée par un autre utilisateur",
    "assignmentConflictDescription": "Cette police a été prise en charge par un autre utilisateur pendant votre absence. Vos modifications ne peuvent pas être soumises. Veuillez rafraîchir la page pour voir l'état le plus récent.",
    "refreshNow": "Rafraîchir maintenant",
    "carGroupTitle": "Véhicule(s)",
    "policyDetailsTitle": "Renseignements généraux",
    "policyDetails": {
      "contract": "Contrat",
      "insuredNameAndAddress": "Nom et adresse postale de l'assuré",
      "documentType": "Type de document",
      "duration": "Durée",
      "insurer": "Assureur",
      "isCrenaux": "Crénaux",
      "prime": "Prime",
      "insuredAddress": "Adresse postale de l'assuré",
      "insuredName": "Nom de l'assuré",
      "insuranceType": "Type d'assurance",
      "billingMethod": "Méthode de facturation"
    },
    "assignments": {
      "title": "Lieux, biens et activités"
    },
    "financialData": {
      "description": "Description",
      "amount": "Montant"
    }
  },
  "policyList": "Validation des polices",
  "policyDetail": "Détails de la police",
  "of": "sur",
  "rowsPerPage": "Lignes par page",
  "documents_one": "{{count}} document",
  "documents_other": "{{count}} documents",
  "PENDING_VALIDATION": "À valider",
  "IN_PROGRESS": "En cours",
  "NOT_COMPLETED": "Non complété",
  "COMPLETED": "Complété",
  "garantie": {
    "title": "Garanties extraites",
    "garanties": "Garanties",
    "formulaire": "Formulaire",
    "rp": "R.P.",
    "franchise": "Franchise",
    "montantGarantie": "Montant de garantie",
    "montantAssurance": "Montant d'assurance",
    "prime": "Prime",
    "noGaranties": "Aucune garantie extraite",
    "vehiculeNumber": "Véhicule n.",
    "year": "Année",
    "description": "Description (Marque, modèle)",
    "serialNumber": "Numéro de série",
    "caracteristics": "Caractéristiques"
  },
  "coverage": {
    "coherentExtraction": "Extraction cohérente",
    "errorDetected": "Erreur détectée",
    "addDescription": "Ajouter une description",
    "required": "obligatoire",
    "descriptionPlaceholder": "Décrivez l'erreur détectée...",
    "addDescriptionTooltip": {
      "intro": "Pour nous aider à corriger l’extraction, merci de préciser :",
      "items": [
        "Où se trouve l’erreur dans le document (section, page, zone)",
        "Le texte exact extrait par l’extracteur",
        "Ce que l’extracteur aurait dû extraire à la place",
        "S’il manque une information (laquelle, et où elle se trouve)",
        "S’il s’agit d’un problème de localisation, de mot/montant mal associé, ou d’info absente"
      ],
      "outro": "Plus votre commentaire est détaillé, plus nous pourrons améliorer rapidement l’extracteur."
    },
    "missingSection": {
      "title": "Section manquante"
    },
    "pageNumber": "Numéro de la page"
  },
  "statusBar": {
    "progress": "{{validated}}/{{total}} - {{errors}} Section(s) validée(s)",
    "submitDisabledTooltip": "Certaines données n'ont pas été validées. Veuillez compléter l'ensemble des tuiles avant de soumettre.",
    "submitSuccess": "La police {{policyNumber}} a été soumise avec succès"
  },
  "externalLink": "Lien externe",
  "billing": {
    "deversement": "Déversement",
    "searchCode": "Code de recherche",
    "accountName": "Nom de compte",
    "policyNumber": "# de Police",
    "policyType": "Type police",
    "insurer": "Assureur",
    "activityCode": "Code activité",
    "effectiveDate": "Date vigueur",
    "expiryDate": "Date échéance",
    "status": "Statut",
    "cv1": "CV1",
    "gc1": "GC1",
    "technicalSupport": "Soutien technique",
    "agencyOrDirectBilling": "Facture agence ou directe",
    "service": "Service",
    "entity": "Entité",
    "inProgress": "En cours",
    "completedDate": "Date terminée",
    "associatedBy": "Assigné à",
    "notes": "Commentaires",
    "agency": "Agence",
    "direct": "Directe",
    "filter": {
      "searchCode": "Filtrer code de recherche...",
      "accountName": "Filtrer nom de compte...",
      "policyNumber": "Filtrer # de police...",
      "policyType": "Filtrer type de police...",
      "insurer": "Filtrer assureur...",
      "activityCode": "Filtrer code d'activité...",
      "agencyOrDirectBilling": "Filtrer facturation...",
      "all": "Tous",
      "associatedBy": "Filtrer assigné à...",
      "status": "Filtrer statut",
      "selected": "sélectionné(s)",
      "clear": "Effacer",
      "technicalSupport": "Filtrer par support technique...",
      "service": "Filtrer par service...",
      "entity": "Filtrer par entité...",
      "gc1": "Filtrer par GC1..."
    },
    "noBillingsFound": "Aucune facturation trouvée",
    "loadingBillings": "Chargement des facturations...",
    "selectedEdocs": "eDocs sélectionnés",
    "assignToMyself": "Assigner ces eDocs à mon compte",
    "markedInProgress": "Facturation marquée comme 'en cours'",
    "failedToChangeStatus": "Échec du changement de statut",
    "drawer": {
      "detailsTab": "Détails",
      "documentsTab": "Documents",
      "noteSaved": "Note enregistrée avec succès",
      "noteSaveError": "Erreur lors de l'enregistrement de la note",
      "statusChanged": "Statut changé à complété avec succès",
      "statusChangeError": "Erreur lors du changement de statut",
      "openByDifferentUser": "Cette police est ouverte par un autre utilisateur.",
      "assignmentConflictError": "Cette facturation a été prise en charge par un autre utilisateur. Veuillez rafraîchir la page.",
      "other": "Autres (texte libre)",
      "saveAsCompleted": "Marquer comme complété",
      "enterComment": "Entrez votre commentaire...",
      "attachmentMetadataError": "Impossible de charger le nom du document dans EPIC",
      "retry": "Réessayer",
      "noAttachmentsFound": "Aucun document trouvé pour cette facturation",
      "policy": "Police",
      "notes": "Notes",
      "document": {
        "name": "Document de police",
        "viewer": "Visionneuse de document",
        "close": "Fermer le document",
        "view": "Afficher le document",
        "hide": "Masquer le document",
        "toRename": "À renommer"
      },
      "process": {
        "label": "Processus",
        "placeholder": "Sélectionner un processus",
        "inferredFrom": "Inféré du code d'activité: {{activityCode}}",
        "loadError": "Impossible de charger les processus"
      },
      "rename": {
        "action": "Renommer",
        "documentType": "Type de document",
        "documentTypePlaceholder": "Sélectionner un type de document",
        "rule": "Règle",
        "newName": "Nouveau nom",
        "completeRequired": "Complétez la valeur requise pour générer le nom",
        "generatedName": "Nom généré",
        "invalidDate": "La date doit être au format AAAA-MM-JJ",
        "invalidAmount": "Le montant doit être un nombre avec au plus 2 décimales, ex. 1234.50 ou -865",
        "folder": "Dossier",
        "subfolder": "Sous-dossier 1",
        "tokens": {
          "processus": "Processus",
          "date": "Date",
          "dateFin": "Date de fin",
          "dateSinistre": "Date du sinistre",
          "prime": "Prime",
          "montant": "Montant",
          "description": "Description",
          "participant": "Participant",
          "projet": "Projet",
          "expert": "Expert"
        }
      }
    },
    "notesHistory": {
      "emptyTitle": "À quoi servent les notes ?",
      "emptyDescription": "Consignez ici les échanges avec le courtier ou l'assuré au sujet de cette facturation : chaque note est datée et signée, pour faciliter la reprise du dossier par un collègue.",
      "authorOnly": "Seul l'auteur d'une note peut la modifier ou la retirer.",
      "predefined": "Note prédéfinie",
      "addNote": "Ajouter une note",
      "noteUpdated": "Note modifiée avec succès",
      "noteUpdateError": "Erreur lors de la modification de la note",
      "noteDeleted": "Note supprimée avec succès",
      "noteDeleteError": "Erreur lors de la suppression de la note",
      "deleteTitle": "Supprimer cette note ?",
      "deleteDescription": "Cette note sera retirée de l'historique de la facturation."
    }
  },
  "billingList": "Validation de la facturation",
  "renewalPrioritizer": "Priorisation de renouvellement",
  "renewal": {
    "comparisonDrawer": "Comparaison de polices",
    "renewalDrawer": "Détails du renouvellement",
    "priorisation": "Priorisation",
    "policyIdentification": "Identification de la police",
    "renewal": "Renouvellement",
    "contractContext": "Contexte du contrat",
    "compensationAndFees": "Rémunération et frais",
    "expiration": "Expiration",
    "alert": "Alerte",
    "notes": "Notes",
    "status": "Statut",
    "assignedTo": "Assigné à",
    "company": "Entreprise",
    "policyNumber": "Numéro de police",
    "type": "Type",
    "insurer": "Assureur",
    "currentPremium": "Prime actuelle",
    "renewalPremium": "Prime renouvellement",
    "premiumVariation": "Variation de prime",
    "amendments": "Avenants",
    "claims": "Sinistres",
    "commissionPercentage": "% commission",
    "fees": "Honoraire",
    "insurerFees": "Frais assureurs",
    "noRenewalsFound": "Aucun renouvellement trouvé",
    "loadingRenewals": "Chargement des renouvellements...",
    "daysAbbr": "jrs",
    "INITIATED": "Initié",
    "IN_PROGRESS": "En cours",
    "STANDBY": "En attente",
    "STANDBY_INSURER": "En attente assureur",
    "DONE": "Terminé",
    "searchRenewal": "Rechercher par numéro de police...",
    "removeFilters": "Effacer les filtres",
    "all": "Tous",
    "self": "Moi",
    "renewalPremiumLabel": "Prime renouvellement",
    "assignedToLabel": "Assigné à",
    "alertsLabel": "Alertes",
    "statusLabel": "Statut",
    "columnsLabel": "Colonnes",
    "expiresIn": "Expire dans",
    "offerNotReceived": "Le comparateur sera disponible une fois la nouvelle offre reçue.",
    "comparator": {
      "limit": "Limite",
      "rate": "Taux",
      "premium": "Prime",
      "comparative": "Comparatif",
      "usageWarning": "Ce tableau comparatif ne comporte pas toutes les clauses présentes au contrat. Il ne s'agit que d'un outil de comparaison de taux et de primes établis.",
      "grandTotal": "Grand total annualisé",
      "noPreviousPeriod": "Pas de période précédente",
      "noRenewalPeriod": "Pas de période de renouvellement"
    },
    "filters": {
      "expiration": {
        "60less": "60 jours ou moins",
        "120less": "120 jours ou moins",
        "180less": "180 jours ou moins",
        "200less": "200 jours ou moins"
      }
    },
    "drawer": {
      "notesTab": "Notes",
      "analyseTab": "Analyse",
      "loadingData": "Chargement des données...",
      "statusChanged": "Statut changé avec succès",
      "statusChangeError": "Erreur lors du changement de statut",
      "noteAdded": "La note a été enregistrée avec succès",
      "addNoteError": "Erreur lors de l'enregistrement de la note",
      "alertsChanged": "Alertes changées avec succès",
      "alertsChangeError": "Erreur lors du changement des alerts",
      "selectAlertsPlaceholder": "Sélectionner des alertes...",
      "assignationError": "Erreur lors de l'assignation du renouvellement",
      "assignedToSelf": "Le renouvellement vous a été assigné avec succès",
      "self": "vous",
      "newPolicyAlert": "La nouvelle police d'assurance est disponible. Vous pouvez dès maintenant comparer vos documents.",
      "viewComparator": "Voir le comparateur",
      "downloadExcel": "Télécharger l'Excel",
      "print": "Imprimer"
    },
    "analysisTab": {
      "details": "Détails",
      "status": "Statut",
      "alerts": "Alertes",
      "assignedTo": "Assigné à",
      "contactName": "Nom du contact",
      "phone": "Téléphone",
      "email": "Courriel",
      "primaryBroker": "Courtier.ère principal",
      "accountManager": "Gestionnaire de compte",
      "branchType": "Type de branche",
      "insurer": "Assureur",
      "profitCenter": "Centre de profit",
      "premiumEvolution": "Évolution de la prime",
      "amendments": "Avenants",
      "claims": "Sinistres",
      "recommendations": "Recommandations",
      "noTransactionsFound": "Il n'y a aucune transaction de cette catégorie."
    },
    "notesTab": {
      "title": "À quoi servent ces notes ?",
      "description": "Cet espace vous permet de consigner rapidement des mises au point, des suivis avec le client, ou l'état actuel du dossier afin de faciliter la reprise du dossier par un collègue.",
      "syncWarning": "Les notes inscrites ne sont pas synchronisées ni liées à l'outil Epic.",
      "addNotePlaceholder": "Ajouter une note"
    },
    "ENTR_AND_CGL": "ENTR & CGL",
    "CGL": "CGL",
    "ENTR": "ENTR",
    "AUTO": "AUTO",
    "CIME": "CIME",
    "UNKNOWN_USER": "Utilisateur inconnu"
  },
  "notes": {
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "daysAgo_one": "Il y a {{count}} jour",
    "daysAgo_other": "Il y a {{count}} jours"
  },
  "documentViewer": {
    "loadError": "Impossible de charger le document"
  }
}
